export const ApiHost = ()=> {
  const override = process.env.REACT_APP_HOST
  if(override){ return 'https://'+override+'/' }

  if(!process.env.REACT_APP_ENV || ['test','development'].includes(process.env.REACT_APP_ENV)) {
    return 'http://dev.tytoonline.com:3000/'
  } else if(process.env.REACT_APP_ENV === 'staging') {
    return 'https://dashboard-staging.tytoonline.com/'
  } else {
    return 'https://dashboard.tytoonline.com/'
  }
}

// Application host will usually be the same as Api host except in test/development.
//
// If the app is deployed separately to S3 or a similar config, then the Application host
// will be entirely different from the Api host.
export const ApplicationHost = ()=> {
  const override = process.env.REACT_APP_HOST
  if(override){ return 'https://'+override+'/' }

  if(!process.env.REACT_APP_ENV || ['test','development'].includes(process.env.REACT_APP_ENV)) {
    return 'http://dev.tytoonline.com:3001/'
  } else if(process.env.REACT_APP_ENV === 'staging') {
    return 'https://dashboard-staging.tytoonline.com/'
  } else {
    return 'https://dashboard.tytoonline.com/'
  }
}

export const AssetHost = ()=> {
  const override = process.env.REACT_APP_ASSET_HOST
  if(override){ return 'https://'+override+'/' }

  if(!process.env.REACT_APP_ENV || ['test','development'].includes(process.env.REACT_APP_ENV)) {
    return 'http://dev.tytoonline.com:8000/'
  } else if(process.env.REACT_APP_ENV === 'staging') {
    return 'https://play-staging.tytoonline.com/'
  } else {
    return 'https://play.tytoonline.com/'
  }
}

export const EmeraldHost = ()=> {
  const override = process.env.REACT_APP_EMERALD_HOST
  if(override){ return 'https://'+override+'/' }

  if(!process.env.REACT_APP_ENV || ['test','development'].includes(process.env.REACT_APP_ENV)) {
    return 'http://dev.tytoonline.com:12345/'
  } else if(process.env.REACT_APP_ENV === 'staging') {
    return 'https://account-staging.tytoonline.com/'
  } else {
    return 'https://account.tytoonline.com/'
  }
}

export const FeedbackLink = () => {
  if(!process.env.REACT_APP_ENV || ['test', 'development', 'staging'].includes(process.env.REACT_APP_ENV)){
    return 'https://feedback.staging.tytoonline.com/'
  }
  else {
    return 'https://feedback.tytoonline.com/'
  }
}